import "./YearFilterDrawer.scss"
import {Drawer} from "antd";
import React from "react";
import {CloseOutlined} from "@ant-design/icons";
import {useYearFilterState} from "../../store/YearFilterState";
import {YearFilterButtons} from "./YearFilterButtons";

export function YearFilterDrawer() {

  const filter = useYearFilterState()

  function onClose() {
    filter.closeDrawer()
  }

  return <Drawer
    id="year-filter-drawer"
    title="Заявлене введення в експлуатацію"
    placement="bottom"
    onClose={onClose}
    open={filter.drawerOpen}
    closeIcon={false}
    height={'25%'}
    extra={<CloseOutlined onClick={() => onClose()}/>}
    styles={{header: {textAlign: "center"}}}>
    <div id="YearFilterDrawerFixedBottom">
      <YearFilterButtons/>
    </div>
  </Drawer>
}